module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/92/assets/images/e21490edd078b4f80815b1ddc1d821a1.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Diamond/Diamond4.svg
// module id = PXvo
// module chunks = 1